import React from "react";
import { Block } from "@randajan/jet-react/dom/block";
import { Caption } from "@randajan/jet-react/dom/caption";
import { Chip } from "@mui/material";

import { Say } from "../../../../../arc/locale/consts.js";
import { mailMeFields } from "../../_forms/MailMeForm/mailMeConfig";


import "./MailMePanel.scss";
import { usePagePop } from "../../../PagePops/PagePops";
import { Locale } from "../../../../assets/Locale.js";

const getMuteTillField = row=>`${row.name}MuteTill`;

const getActiveMuteTill = (profile, row, now)=>{
    const value = profile[getMuteTillField(row)];
    if (!value) { return null; }

    const date = new Date(value);
    if (Number.isNaN(date.getTime()) || date.getTime() <= now) { return null; }

    return date;
};

const getMailMeState = (profile, row, now)=>{
    const muteTill = getActiveMuteTill(profile, row, now);
    if (muteTill) {
        return { className:"isPaused", labelId:Say.id("profile", "mailMe", "state", "muted") };
    }

    const checked = !!profile[row.name];
    return {
        className:checked ? "isPositive" : "isMuted",
        labelId:Say.id("profile", "mailMe", "state", checked ? "on" : "off")
    };
};

const MailMePanelRow = (props)=>{
    const { now, profile, row } = props;
    const say = Locale.use();
    const Icon = row.icon;
    const state = getMailMeState(profile, row, now);
    const fieldId = (...parts)=>Say.id("profile", "mailMe", "field", row.name, ...parts);

    return (
        <li>
            <Icon fontSize="small" />
            <Block caption={say(fieldId("label"))}>
                <p className="font -fade">{say(fieldId("summary"))}</p>
            </Block>
            <Chip
                className={`BlimpMuiPanel-status ${state.className} primary`}
                label={say(state.labelId)}
                variant="outlined"
            />
        </li>
    );
};

export const MailMePanel = (props)=>{
    const { profile={} } = props;

    const pop = usePagePop("mailMeForm");
    const say = Locale.use();
    const now = Date.now();

    return (
        <Block tagName="section" className="MailMePanel wall -form -checklist">
            <div className="header">
                <Caption>{say("profileMailMeCaption")}</Caption>
            </div>
            <ul className="iconized">
                {mailMeFields.map(row=>(
                    <MailMePanelRow key={row.name} now={now} profile={profile} row={row} />
                ))}
            </ul>
            <section className="controls">{pop?.button}</section>
        </Block>
    );
};
